<!-- @format -->

<div class="hmf-w-100">
	<div class="skeleton-fulfillment-section">
		<span class="hmf-body-s">Fulfillment</span>

		<div
			class="hmf-display-flex hmf-flex-wrap hmf-justify-content-between hmf-align-content-center hmf-flex-column hmf-w-100">
			<div
				class="fulfillment-row hmf-display-flex hmf-mt-xxs hmf-mb-xxs hmf-pb-xxs hmf-pb-sm-0">
				<hmf-skeleton
					[loading]="true"
					width="10px"
					height="10px"
					borderRadius="50%"
					class="hmf-align-self-center hmf-mr-xxxs"></hmf-skeleton>
				<hmf-skeleton
					[loading]="true"
					width="80%"
					height="14px"
					class="hmf-flex-grow"></hmf-skeleton>
			</div>

			<div class="fulfillment-row hmf-display-flex hmf-pb-xs hmf-pb-sm-0">
				<hmf-skeleton
					[loading]="true"
					width="10px"
					height="10px"
					borderRadius="50%"
					class="hmf-align-self-center hmf-mr-xxxs"></hmf-skeleton>
				<hmf-skeleton
					[loading]="true"
					width="80%"
					height="14px"
					class="hmf-flex-grow"></hmf-skeleton>
			</div>
		</div>
	</div>
</div>
